<template>
  <div class="vg_wrapper">
    <EditHeader
      :btn="btn"
      :isShow="isShow"
      :special="true"
      :strForm="{ status: formStatus }"
      @closeEdit="closeEdit"
      @openEdit="openEdit"
      @refresh="initData"
      @submit="submit"
    >
      <span slot="otherButton" class="vg_mr_8 flexHV">
        单据号: <el-tag type="info">{{ purmaterial_orders_no }}</el-tag>
      </span>
      <div slot="specialStatus" style="display: flex">
        <div class="flexHV">
          <span>状态：</span>
          <el-tag :type="helper.getStatusName(formStatus).type">{{ helper.getStatusName(formStatus).name }}</el-tag>
        </div>
      </div>
    </EditHeader>
    <MainForm ref="MainForm" :is-edit="true" :is-show="isShow"></MainForm>
    <SubTable ref="SubTable" :is-show="isShow" @refreshData="initData"></SubTable>
    <el-row class="vg_mt_16 vd_bortop">
      <el-col>
        <!--<inputUser ref="userData" :isCookie="false" :stffForm="s
        tffForm"></inputUser>-->
      </el-col>
    </el-row>
  </div>
</template>

<script>
import EditHeader from '@/views/component/editHeaderLine.vue';
import inputUser from '@/views/component/inputUser.vue';
import DynamicForm from '@/components/DynamicFormV2.vue';
import { requiredReminderAndUGrid } from '@assets/js/domUtils';
import UrlEncode from '@assets/js/UrlEncode';
import MainForm from '@/views/PurcManagement/FinishedProductAndMaterialOrder/TabChild/mainform.vue';
import SubTable from '@/views/PurcManagement/FinishedProductAndMaterialOrder/TabChild/subTable.vue';
import { api } from '@/views/PurcManagement/FinishedProductAndMaterialOrder/js/api';

export default {
  name: 'FinishedProductAndMaterialOrderEditMain',
  components: {
    SubTable,
    DynamicForm,
    EditHeader,
    inputUser,
    MainForm
  },
  provide() {
    return {
      shareData: this.shareData
    };
  },
  data() {
    return {
      shareData: { purmaterial_orders_id: 0, file_address: null, isShowBtnAndFields: true, purmaterial_orders_no: '' },
      isShow: true,
      btn: {},
      stffForm: {},
      formStatus: 0,
      purmaterial_orders_no: '',
      purmaterial_orders_id: ''
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      this.getDataList();
    },
    openEdit() {
      this.isShow = false;
      this.$emit('isShow', this.isShow);
    },
    closeEdit() {
      this.$confirm('是否撤销编辑?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      })
        .then(() => {
          this.isShow = true;
          this.$emit('isShow', this.isShow);
          this.initData();
          this.$message({
            type: 'info',
            message: '已撤销编辑!'
          });
        })
        .catch(() => {});
    },
    getDataList() {
      const props = JSON.parse(UrlEncode.decode(this.$route.query.key));
      api.get_rmaterial_orders_by_id({ purmaterial_orders_id: props.form_id }).then(({ data }) => {
        this.btn = data.btn;
        this.purmaterial_orders_id = data.form.purmaterial_orders_id;
        this.purmaterial_orders_no = data.form.purmaterial_orders_no;
        this.shareData.purmaterial_orders_id = data.form.purmaterial_orders_id;
        this.shareData.file_address = data.form.file_address;
        this.shareData.purmaterial_orders_no = data.form.purmaterial_orders_no;
        const acct_id = this.$cookies.get('userInfo').acct_id;

        this.shareData.isShowBtnAndFields = acct_id === 22 ? data.form.chinese_supplier_name === '常吉纺织' : true;

        this.formStatus = data.form.status;
        this.$refs.MainForm.formProperties.forEach(item => {
          item.model = data.form[item.prop];
        });
        this.$refs.SubTable.subTableData = data.form.rmaterialOrdersItemsList;
        this.stffForm = this.changeStaffForm(this.stffForm, data.form);
      });
    },
    submit(formName) {
      this.$confirm('确认保存?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let dynamicUTable = await this.$refs.SubTable.$refs.dynamicUTable.fullValidateMsg();
          let form1 = {};
          await this.$refs.MainForm.$refs.dynamicForm.$refs.form.validate((valid, object) => (form1 = object));

          if (Object.keys(form1).length === 0 && !dynamicUTable) {
            this.saveInfo();
          } else {
            let tempStr = '';
            if (dynamicUTable) tempStr += `子表-${dynamicUTable}|`;
            requiredReminderAndUGrid({ ...form1 }, tempStr);
          }
        })
        .catch(err => console.error(err));
    },
    saveInfo() {
      api.edit_rmaterial_orders(this.getSaveData()).then(({ data }) => {
        this.$message.success('保存成功!');
        this.initData();
        this.isShow = true;
        this.$emit('isShow', this.isShow);
      });
    },
    getSaveData() {
      let formModel = this.$refs.MainForm.$refs.dynamicForm.getFormModel();
      formModel.purmaterial_orders_id = this.purmaterial_orders_id;
      formModel.rmaterialOrdersItemsList = this.$refs.SubTable.subTableData;
      formModel.status = this.formStatus;
      return formModel;
    },
    changeStaffForm(staffForm, dataForm) {
      staffForm.stff_name = dataForm.stff_name;
      staffForm.dept_name = dataForm.dept_name;
      staffForm.dept_team_name = dataForm.dept_team_name;
      staffForm.user_id = dataForm.user_id;
      staffForm.dept_id = dataForm.dept_id;
      staffForm.stff_id = dataForm.stff_id;
      return staffForm;
    }
  }
};
</script>

<style lang="scss" scoped></style>
